import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";

function ContactSection() {
  return (
    <section id="contact" className="bg-dark section-spacing landing-page-text">
      <Container>
        {/* <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">Get In Touch</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: "700px" }}>
            Have questions about our service? Need assistance? We're here to
            help you make the most of AskLMS.
          </p>
        </div> */}
        {/* <Row className="g-4 justify-content-center">
          <Col lg={5}>
            <div className="animate-on-scroll">
              <div className="mb-4">
                <h3 className="h4 mb-3">Contact Information</h3>
                <p className="text-muted">
                  Our team is ready to assist you with any questions about our
                  AI services. Reach out to us!
                </p>
              </div>
              <div className="d-flex mb-4">
                <div className="me-3">
                  <FaEnvelope className="text-primary fs-4" />
                </div>
                <div>
                  <h4 className="h6 mb-1">Email Us</h4>
                  <p className="text-muted mb-0">support@asklms.com</p>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="me-3">
                  <FaPhone className="text-primary fs-4" />
                </div>
                <div>
                  <h4 className="h6 mb-1">Call Us</h4>
                  <p className="text-muted mb-0">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="d-flex">
                <div className="me-3">
                  <FaMapMarkerAlt className="text-primary fs-4" />
                </div>
                <div>
                  <h4 className="h6 mb-1">Location</h4>
                  <p className="text-muted mb-0">
                    123 AI Avenue, Tech District
                    <br />
                    San Francisco, CA 94105
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="animate-on-scroll">
              <Card className="border-0">
                <Card.Body className="p-4 landing-dark-background landing-page-text custom-form">
                  <h3 className="h4 mb-4">Send Us A Message</h3>
                  <Form>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="contactName">
                          <Form.Label>Your Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter your name"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="contactEmail">
                          <Form.Label>Email Address</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="contactSubject">
                          <Form.Label>Subject</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="What is this regarding?"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="contactMessage">
                          <Form.Label>Message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Your message here..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Button
                          variant="primary"
                          className="rounded-pill px-4 py-2"
                          type="submit"
                        >
                          Send Message
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row> */}

        <div className="animate-on-scroll d-flex align-items-center justify-content-between">
          {/* Left Side: Title and Description */}
          <div>
            <h3 className="h4 mb-3">Contact Information</h3>
            <p className="text-muted">
              Our team is ready to assist you with any questions about our AI
              services. Reach out to us!
            </p>
          </div>

          {/* Right Side: Contact Details */}
          <div className="ps-2">
            <div className="d-flex mb-4">
              <div className="me-3">
                <FaEnvelope className="text-primary fs-4" />
              </div>
              <div>
                <h4 className="h6 mb-1">Email Us</h4>
                <p className="text-muted mb-0">info@asklms.com</p>
              </div>
            </div>

            <div className="d-flex mb-4">
              <div className="me-3">
                <FaPhone className="text-primary fs-4" />
              </div>
              <div>
                <h4 className="h6 mb-1">Call Us</h4>
                <p className="text-muted mb-0">0416 - 635 - 924</p>
              </div>
            </div>

            <div className="d-flex">
              <div className="me-3">
                <FaMapMarkerAlt className="text-primary fs-4" />
              </div>
              <div>
                <h4 className="h6 mb-1">Location</h4>
                <p className="text-muted mb-0">
                  1C Grand Ave, Rosehill NSW 2142,
                  <br />
                  Australia
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ContactSection;
